import React, { useEffect, useRef, useState } from 'react';
import * as rsuite from 'rsuite';

import Layout from '../../Layout/PrivateLayout';
import * as General from '../General/General';
import { trackPromise } from 'react-promise-tracker';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import * as BiIcon from "react-icons/bi";
// import Drp_DocSaveType from '../AccountDocSettings/Drp_DocSaveType';
import Auto_User from '../User/Auto_User';
import Auto_ACCGL from '../AccountDetail/Auto_ACCGL';
import moment from 'moment-jalaali';
import DatePicker from 'react-datepicker2';
import PN from "persian-number";



const GeneralLedgerReportIndex = () => {

    //#region Const
    const toaster = rsuite.useToaster();
    const rowKey = 'id';
    let navigate = useNavigate();
    const UserRef = useRef()
    const ACCGLRef = useRef();
    const [List, setList] = useState([]);
    const [FiscalYearId, setFiscalYearId] = useState(localStorage.getItem("FiscalYearId"));
    const [Comment, setComment] = useState('');
    // const [SystemNumber, setSystemNumber] = useState('');
    // const [Number, setNumber] = useState('');
    // const [SerialNo, setSerialNo] = useState('');
    const [User, setUser] = useState('');
    const [UserId, setUserId] = useState(General.GuidEmpty());
    const [Acc_GLId, setAcc_GLId] = useState(General.GuidEmpty());
    const [Acc_GLTitle, setAcc_GLTitle] = useState("");
    const [BeginDate, setBeginDate] = useState(moment(new Date()).add("Day", -7));
    const [EndDate, setEndDate] = useState(moment(new Date()));
    const [RegisterBeginDate, setRegisterBeginDate] = useState(moment(new Date()).add("Day", -7));
    const [RegisterEndDate, setRegisterEndDate] = useState(moment(new Date()));
    const [loading, setLoading] = React.useState(false)

    const [sortColumn, setSortColumn] = React.useState();
    const [sortType, setSortType] = React.useState()
    const CompactCell = props => <rsuite.Table.Cell {...props} style={{ padding: 4 }} />;
    const CompactHeaderCell = props => <rsuite.Table.HeaderCell {...props} style={{ padding: 4 }} />;
    const defaultColumns = [
        {
            key: 'row',
            label: '#',
            fixed: true,
            sortable: true,
            width: 50
        },

        {
            key: 'CreateDate',
            label: 'تاریخ ثبت سیستمی',
            fullText: true,
            sortable: true,
            fixed: true,
            flexGrow: 2

        },
        {
            key: 'RegisterDate',
            label: 'تاریخ سند',
            fullText: true,
            sortable: true,
            fixed: true,
            flexGrow: 2
        },
        {
            key: 'SystemNumber',
            label: 'شماره سند',
            fixed: true,
            fullText: true,
            resizable: true,
            sortable: true,
            flexGrow: 1
        },
        {
            key: 'Number',
            label: 'عطف سند',
            fixed: true,
            fullText: true,
            resizable: true,
            sortable: true,
            flexGrow: 1
        },
        {
            key: 'SerialNo',
            label: 'سریال',
            fullText: true,
            resizable: true,
            sortable: true,
            flexGrow: 1
        },
        {
            key: 'CreateUser',
            label: 'کاربر',
            fullText: true,
            resizable: true,
            sortable: true,
            flexGrow: 2
        },

        {
            key: 'ACCGL',
            label: 'حساب',
            fullText: true,
            resizable: true,
            sortable: true,
            flexGrow: 3
        },
        {
            key: 'Comment',
            label: ' توضیحات',
            fullText: true,
            resizable: true,
            sortable: true,
            flexGrow: 4
        }
        ,
        {
            key: 'CreditComment',
            label: 'بستانکار (ریال)',
            fullText: true,
            resizable: true,
            sortable: true,
            className: 'text-success',
            flexGrow: 2
        },
        {
            key: 'DebitComment',
            label: 'بدهکار (ریال)',
            fullText: true,
            resizable: true,
            sortable: true,
            className: 'text-danger',
            flexGrow: 2
        },
        {
            key: 'RemainComment',
            label: ' باقیمانده (ریال)',
            fullText: true,
            className: "RemainClass",
            resizable: true,
            sortable: true,
            flexGrow: 2
        },

    ];

    const handleSortColumn = (sortColumn, sortType) => {
        setLoading(true);
        setTimeout(() => {
            setLoading(false);
            setSortColumn(sortColumn);
            setSortType(sortType);
        }, 500);
    };
    const handleChangeLimit = dataKey => {
        setPage(1);
        setLimit(dataKey);
    };


    const [compact, setCompact] = React.useState(true);
    const [columnKeys, setColumnKeys] = React.useState(defaultColumns.map(column => column.key));

    const columns = defaultColumns.filter(column => columnKeys.some(key => key === column.key));
    const CustomCell = compact ? CompactCell : rsuite.Table.Cell;
    const CustomHeaderCell = compact ? CompactHeaderCell : rsuite.Table.HeaderCell;
    const [limit, setLimit] = React.useState(10);
    const [page, setPage] = React.useState(1);


    //#endregion



    const User_Select = (e) => {
        setUserId(e.split("|")[0])
        setUser(e.split("|")[1])
    }

    const User_Change = (e) => {
        console.dir(e)
        setUserId(General.GuidEmpty())
        if (e.split("|").length > 1) {
            setUser(e.split("|")[1]);
            return;
        }
        setUser(e);
        UserRef.current.BindCoWorker(e)

    }

    const ACCGL_Change = (e) => {
        setAcc_GLId(General.GuidEmpty())
        if (e.split("|").length > 1) {
            setAcc_GLTitle(e.split("|")[1]);
            return;
        }
        setAcc_GLTitle(e);
        ACCGLRef.current.Bind(e)

    }


    const ACCGL_Select = (e) => {
        setAcc_GLId(e.split("|")[0])
        setAcc_GLTitle(e.split("|")[1])
    }



    const BeginDate_Change = e => {
        var m = moment(e.format()).format('jYYYY/jMM/jDD');
        setBeginDate(moment(m, 'jYYYY/jMM/jDD'));
    }

    const EndDate_Change = e => {
        var m = moment(e.format()).format('jYYYY/jMM/jDD');
        setEndDate(moment(m, 'jYYYY/jMM/jDD'));
    }


    const RegisterBeginDate_Change = e => {
        var m = moment(e.format()).format('jYYYY/jMM/jDD');
        setRegisterBeginDate(moment(m, 'jYYYY/jMM/jDD'));
    }

    const RegisterEndDate_Change = e => {
        var m = moment(e.format()).format('jYYYY/jMM/jDD');
        setRegisterEndDate(moment(m, 'jYYYY/jMM/jDD'));
    }


    //#region Methods


    const Search = () => {

        var RequestOptions = {
            data: {
                'FiscalYearId': FiscalYearId * 1,
                'CreateUserId': UserId,
                'Comment': Comment,
                // 'Number': Number == "" ? 0 : Number * 1,
                // 'SerialNo': SerialNo == "" ? 0 : SerialNo * 1,
                // 'SystemNumber': SystemNumber == "" ? 0 : SystemNumber * 1

            },
            url: General.ApiRoute() + "/Account_Doc/GeneralLefgerReport",
            method: "post",
            withCredentials: true,

            headers: {
                'ApiKey': General.APIKey(),
                'Acc_GLId': Acc_GLId,
                'BeginDate': BeginDate != null ? moment(BeginDate.format()).format("jYYYY/jMM/jDD") : "",
                'EndDate': EndDate != null ? moment(EndDate.format()).format("jYYYY/jMM/jDD") : "",
                'RegisterBeginDate': RegisterBeginDate != null ? moment(RegisterBeginDate.format()).format("jYYYY/jMM/jDD") : "",
                'RegisterEndDate': RegisterEndDate != null ? moment(RegisterEndDate.format()).format("jYYYY/jMM/jDD") : "",
                'Content-Type': 'application/json'
            }
        }


        trackPromise(
            axios(RequestOptions)
                .then(function (result) {
                    var tmp = []
                    console.dir(result.data)
                    console.dir(result.data.length)
                    for (var i = 0; i < result.data.length; i++) {
                        tmp.push({
                            row: i + 1,
                            CreateUser: result.data[i].createUser,
                            Number: result.data[i].number,
                            RegisterDate: result.data[i].registerDate,
                            CreateDate: result.data[i].createDate,
                            SerialNo: result.data[i].serialNo,
                            SystemNumber: result.data[i].systemNumber,
                            Comment: result.data[i].comment,
                            TotalPrice: PN.sliceNumber(result.data[i].totalPrice),
                            DebitComment: PN.sliceNumber(result.data[i].debitPrice),
                            CreditComment: PN.sliceNumber(result.data[i].creditPrice),
                            RemainComment: result.data[i].acc_GLRemain > 0 ? PN.sliceNumber(result.data[i].acc_GLRemain) + " بس" : result.data[i].acc_GLRemain < 0 ? PN.sliceNumber(result.data[i].acc_GLRemain * (-1)) + " بد" : "تسویه",
                            // RemainClass: result.data[i].acc_GLRemain > 0 ? "text-success" : "text-danger",
                            Acc_GLTitle: result.data[i].acc_GLTitle,
                            Acc_GLCode: result.data[i].acc_GLCode,
                            DebitPrice: result.data[i].debitPrice,
                            CreditPrice: result.data[i].creditPrice,
                            Acc_GLRemain: result.data[i].acc_GLRemain,
                            ACCGL: result.data[i].acc_GLTitle + " [" + result.data[i].acc_GLCode + "]",

                        })
                    }
                    setList(tmp)
                }).catch((error) => {
                    toaster.push(General.ShowMessage('error', General.ErrorMessage(error)), 'topCenter')

                })
        )

    }





    // const Print = (id) => {
    //     navigate("/PrintDoc")
    //     localStorage.setItem("BackPage", "Doc");
    //     localStorage.setItem("DocHeaderId", id)
    // }




    const CheckPermission = () => {
        var myHeaders = new Headers();
        myHeaders.append("ApiKey", General.APIKey());
        myHeaders.append("Page", 35);
        myHeaders.append("Operation", 0);

        var requestOptions = {
            method: "Get",
            headers: myHeaders,
            credentials: 'include'

        };
        trackPromise(
            fetch(General.ApiRoute() + "/Common/CheckPermission", requestOptions)
                .then(response => response.text())
                .then(result => {
                    if (result.toString() != "OK") {
                        navigate("/AccessDenied");
                    }
                    else {
                        Search();
                        UserRef.current.BindCoWorker("");
                        ACCGLRef.current.Bind();
                    }
                }).catch((error) => {
                    toaster.push(General.ShowMessage('error', General.ErrorMessage(error)), 'topCenter')
                })
        )
    }


    const handelKeyDown = (e, row) => {
        if (e.key == "Enter") {
            Search();
        }


    }

    useEffect(() => {
        CheckPermission();
        document.title = "دفتر کل ";
        const inputElement = document.querySelector('.FocusItem');
        if (inputElement) {
            inputElement.focus();
        }
    }, [])
    //#endregion







    return (

        <Layout title=" دفتر کل">


            <div className="h-100 p-1" onKeyDown={handelKeyDown}>
                <rsuite.Panel className="bg-white ">
                    <rsuite.Grid fluid>
                        <rsuite.Row>

                            <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24} className="text-left" >
                                <rsuite.Button appearance="primary" size="xs" className="m-1" onClick={Search}>  جستجو</rsuite.Button>

                            </rsuite.Col>
                        </rsuite.Row>
                    </rsuite.Grid>
                    <hr />
                    <rsuite.Row className='p-1'>
                        <rsuite.Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={24}>
                            <label> از تاریخ ثبت </label>
                            <rsuite.InputGroup>
                                <rsuite.Button color="red" onClick={() => setBeginDate(null)} appearance="subtle" className='border border-danger'>
                                    <BiIcon.BiX size={15}></BiIcon.BiX>
                                </rsuite.Button>
                                <DatePicker className="rs-input" isGregorian={false} timePicker={false} icon={BiIcon.BiCalendar} value={BeginDate} onChange={BeginDate_Change} />
                            </rsuite.InputGroup>
                        </rsuite.Col>
                        <rsuite.Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={24}>
                            <label>تا تاریخ ثبت </label>
                            <rsuite.InputGroup>
                                <rsuite.Button color="red" onClick={() => setEndDate(null)} appearance="subtle" className='border border-danger'>
                                    <BiIcon.BiX size={15}></BiIcon.BiX>
                                </rsuite.Button>
                                <DatePicker className="rs-input" isGregorian={false} timePicker={false} icon={BiIcon.BiCalendar} value={EndDate} onChange={EndDate_Change} />

                            </rsuite.InputGroup>

                        </rsuite.Col>
                        <rsuite.Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={24}>
                            <label> از تاریخ سند </label>
                            <rsuite.InputGroup>
                                <rsuite.Button color="red" onClick={() => setRegisterBeginDate(null)} appearance="subtle" className='border border-danger'>
                                    <BiIcon.BiX size={15}></BiIcon.BiX>
                                </rsuite.Button>
                                <DatePicker className="rs-input" isGregorian={false} timePicker={false} icon={BiIcon.BiCalendar} value={RegisterBeginDate} onChange={RegisterBeginDate_Change} />
                            </rsuite.InputGroup>
                        </rsuite.Col>
                        <rsuite.Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={24}>
                            <label>تا تاریخ سند </label>
                            <rsuite.InputGroup>
                                <rsuite.Button color="red" onClick={() => setRegisterEndDate(null)} appearance="subtle" className='border border-danger'>
                                    <BiIcon.BiX size={15}></BiIcon.BiX>
                                </rsuite.Button>
                                <DatePicker className="rs-input" isGregorian={false} timePicker={false} icon={BiIcon.BiCalendar} value={RegisterEndDate} onChange={RegisterEndDate_Change} />

                            </rsuite.InputGroup>

                        </rsuite.Col>
                    </rsuite.Row>
                    {/* <rsuite.Row className='p-1'>
                        <rsuite.Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                            <label> از تاریخ ثبت </label>
                            <DatePicker className="rs-input" isGregorian={false} timePicker={false} icon={BiIcon.BiCalendar} value={BeginDate} onChange={BeginDate_Change} />
                        </rsuite.Col>
                        <rsuite.Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                            <label>تا تاریخ ثبت </label>
                            <DatePicker className="rs-input" isGregorian={false} timePicker={false} icon={BiIcon.BiCalendar} value={EndDate} onChange={EndDate_Change} />
                        </rsuite.Col>
                        <rsuite.Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                            <label> از تاریخ </label>
                            <DatePicker className="rs-input" isGregorian={false} timePicker={false} icon={BiIcon.BiCalendar} value={RegisterBeginDate} onChange={RegisterBeginDate_Change} />
                        </rsuite.Col>
                        <rsuite.Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                            <label>تا تاریخ </label>
                            <DatePicker className="rs-input" isGregorian={false} timePicker={false} icon={BiIcon.BiCalendar} value={RegisterEndDate} onChange={RegisterEndDate_Change} />
                        </rsuite.Col>
                    </rsuite.Row> */}
                    <rsuite.Row>

                        <rsuite.Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={24}>
                            <label>حساب کل  </label>
                            <Auto_ACCGL className="rs-input" value={Acc_GLTitle} onChange={ACCGL_Change} onSelect={ACCGL_Select} ref={ACCGLRef} />
                        </rsuite.Col>
                        <rsuite.Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={24}>
                            <label> کاربر </label>
                            <Auto_User className="rs-input" value={User} onChange={User_Change} onSelect={User_Select} ref={UserRef} />
                        </rsuite.Col>
                        <rsuite.Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={24}>
                            <label> شرح </label>
                            <rsuite.Input className='FocusItem' value={Comment} onChange={(e) => setComment(e)} />
                        </rsuite.Col>
                        <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                            <label> فیلتر   </label>
                            <rsuite.VStack spacing={16}>

                                <rsuite.TagPicker
                                    data={defaultColumns}
                                    labelKey="label"
                                    valueKey="key"
                                    value={columnKeys}
                                    onChange={setColumnKeys}
                                    cleanable={false}
                                    className='Font10 w-100p'
                                />
                            </rsuite.VStack>
                        </rsuite.Col>
                    </rsuite.Row>


                    <div className="h-90 p-1">
                        <div className="h-100-y">

                            <rsuite.Panel className="bg-white mt-2">

                                <rsuite.Table

                                    minHeight={450}
                                    loading={loading}
                                    data={List.sort((a, b) => {
                                        let x = a[sortColumn];
                                        let y = b[sortColumn];
                                        if (typeof x === 'string') {
                                            x = x.charCodeAt();
                                        }
                                        if (typeof y === 'string') {
                                            y = y.charCodeAt();
                                        }
                                        if (sortType === 'asc') {
                                            return x - y;
                                        } else {
                                            return y - x;
                                        }
                                    }).filter((v, i) => {
                                        const start = limit * (page - 1);
                                        const end = start + limit;
                                        return i >= start && i < end;
                                    })}
                                    sortColumn={sortColumn}
                                    sortType={sortType}
                                    onSortColumn={handleSortColumn}


                                >
                                    {columns.map(column => {

                                        const { key, label, className, ...rest } = column;
                                        {


                                            return (
                                                <rsuite.Table.Column {...rest} key={key}>
                                                    <CustomHeaderCell>{label}</CustomHeaderCell>
                                                    <rsuite.Table.Cell {...rest} dataKey={key}>
                                                        {rowData => {
                                                            let dynamicClass = "";

                                                            if (key === "CreditComment") {
                                                                dynamicClass = "text-success";
                                                            } else if (key === "DebitComment") {
                                                                dynamicClass = "text-danger";
                                                            } else if (key === "RemainComment") {
                                                                const value = rowData?.[key]; // 👈 مقدار ستون برای این ردیف
                                                                dynamicClass = String(value ?? "")
                                                                    .replace(/\s+/g, "")
                                                                    .includes("بس")
                                                                    ? "text-success"
                                                                    : String(value ?? "")
                                                                        .replace(/\s+/g, "")
                                                                        .includes("بد") ? "text-danger" : "fw-bold";
                                                            }

                                                            return <span className={`${className || ""} ${dynamicClass}`}>{rowData[key]}</span>;
                                                        }}
                                                    </rsuite.Table.Cell>
                                                </rsuite.Table.Column>
                                            );
                                        }
                                    })}


                                </rsuite.Table>

                                <div style={{ paddingTop: 20 }}>
                                    <rsuite.Pagination
                                        prev
                                        next
                                        first
                                        last
                                        ellipsis
                                        boundaryLinks
                                        maxButtons={5}
                                        size="xs"
                                        layout={['total', '-', 'limit', '|', 'pager', 'skip']}
                                        total={List.length}
                                        limitOptions={[5, 10, 30, 50, 100]}
                                        limit={limit}
                                        activePage={page}
                                        onChangePage={setPage}
                                        onChangeLimit={handleChangeLimit}
                                    />
                                </div>



                            </rsuite.Panel>

                        </div>
                    </div >
                    <rsuite.Row>
                        <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                            <rsuite.Divider></rsuite.Divider>
                            <small><b> Enter :</b> جستجو </small>
                        </rsuite.Col>
                    </rsuite.Row>

                </rsuite.Panel >
            </div >


        </Layout >


    )
}

export default GeneralLedgerReportIndex;